import axios from 'axios';
import authToken from './authToken';
import cfac22 from '../cfac22';

export function createNotificationToken(uid, partnerId, notificationToken) {
  return new Promise((resolve, reject) => {
    authToken(uid).then((token) => {
      axios
        .post(
          cfac22('API_HOST_V2') + '/notification/token/create',
          {
            uid,
            partnerId,
            token: notificationToken,
            app: 'webapp',
            type: 'web-app',
          },
          {
            headers: { authorization: 'Bearer ' + token, 'Full-Url': window.location.href },
          }
        )
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  });
}
